import { AuthPageLayout } from './ui/authPageLayout';

const AuthPage = () => {
  return (
    <AuthPageLayout
      title="«Название платформы» - Админ"
      subtitle="Вход в административную панель"
      phone="+7 (987) 654-32-10"
      email="admin@domain.ru"
    />
  );
};

export { AuthPage };
